<custom-cx-navigation-ui [node]="node$ | async" [ngClass]="(styleClass$ | async) ?? ''" [navAriaLabel]="name$ | async">
</custom-cx-navigation-ui>
